import { useParams } from "react-router-dom";
import CustomViewRenderer from "@webcore/components/domain/dashboard/renderers/custom/CustomViewRenderer.tsx";

/**
 * Ops route for a custom dashboard view. Reads the view identifiers from the path and renders the
 * shared CustomViewRenderer against the read-only session established by MfeBootstrap.
 */
function OpsCustomViewRoute() {
  const { dashboardId, viewId, dataPipelineConfigurationId } = useParams<{
    dashboardId: string;
    viewId: string;
    dataPipelineConfigurationId: string;
  }>();

  if (dashboardId === undefined || viewId === undefined || dataPipelineConfigurationId === undefined) {
    return <div className="widget-error">Missing view parameters.</div>;
  }

  return (
    <CustomViewRenderer
      dashboardId={dashboardId}
      viewId={viewId}
      dataPipelineConfigurationId={dataPipelineConfigurationId}
    />
  );
}

export default OpsCustomViewRoute;
